module.exports = __webpack_public_path__ + "static/media/020-smartphone-1.41aec2b9.svg";